import React from 'react';
import DotsLoading from '../../../components/dotsLoading';
import {useParams} from 'react-router-dom';
import useGetTransaction from '../../../services/hookService/my-account/getTransaction/useGetTransaction';

const PaymentLoading = () => {
  const {guid, ipg_type} = useParams();

  useGetTransaction({ipg_type: ipg_type || '', guid});

  return (
    <div className="w-full h-full flex flex-col bg-white justify-center items-center">
      <DotsLoading />
    </div>
  );
};

export default PaymentLoading;
